import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Accordion from '../../src/components/Accordion/Accordion';
import Checkbox from '../../src/components/Checkbox/Checkbox';
import Input from '../../src/components/Input/Input';
import DateTimeInput from '../../src/components/DateTimeInput/DateTimeInput';
import JsonEditor from './JsonEditor';
import createFakeEvent from '../../src/lib/createFakeEvent';
import { isMomentPropType } from '../../src/lib/customPropTypes';

const INVALID = [PropTypes.func, PropTypes.func.isRequired];

/**
 * A component for displaying PropTypes of a React component.
 */
export default class Properties extends Component {

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    createField: PropTypes.func,
    defaultProps: PropTypes.object,
    editable: PropTypes.bool,
    exclude: PropTypes.array,
    expanded: PropTypes.bool,
    level: PropTypes.number,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    propTypes: PropTypes.object,
    title: PropTypes.string,
    propValues: PropTypes.object,
  };

  static defaultProps = {
    defaultProps: {},
    editable: true,
    expanded: true,
    level: 2,
    propTypes: {},
    propValues: {},
    title: 'Props'
  };

  onChange = (key, e) => {
    const { defaultProps, onChange, propTypes, propValues } = this.props;
    const props = { ...defaultProps, ...propValues };

    if (onChange) {
      const type = propTypes[key];
      let value = e.target.value;

      if (type === PropTypes.number || type === PropTypes.number.isRequired) {
        value = parseInt(value, 10);
      } else if (type === PropTypes.string || type === PropTypes.string.isRequired) {
        value = e.target.value;
      }
      props[key] = value;
      this.props.onChange(createFakeEvent(props, e), key, value);
    }
  };

  onMomentChange = (key, date) => {
    const { defaultProps, onChange, propValues } = this.props;
    const props = { ...defaultProps, ...propValues };

    if (onChange) {
      props[key] = date;
      this.props.onChange(createFakeEvent(props), key, date);
    }
  };

  createField = (key) => {
    const { defaultProps, propTypes, editable, propValues } = this.props;
    const values = { ...defaultProps, ...propValues };
    const type = propTypes[key];
    const value = values[key];
    const onChange = this.onChange.bind(this, key);

    if (editable) {
      if (type === PropTypes.string || type === PropTypes.string.isRequired || type === PropTypes.node ||type === PropTypes.node.isRequired) {
        return <Input id={key} value={value} onChange={onChange}/>;
      } else if (type === PropTypes.number || type === PropTypes.number.isRequired) {
        return <Input id={key} value={!isNaN(value) ? value : ''} onChange={onChange} type="number"/>;
      } else if (type === PropTypes.bool || type === PropTypes.bool.isRequired) {
        return <Checkbox id={key} onChange={onChange} checked={value === true || value === 'on'}/>;
      } else if (type === isMomentPropType) {
        return <DateTimeInput id={key} onChange={this.onMomentChange.bind(this, key)} selected={value} isClearable showSeconds showConfirm/>;
      }
    }
    return <JsonEditor onChange={onChange} id={key} data={value}/>;
  };

  render() {
    const { children, expanded, propTypes, createField = this.createField, exclude = [], onClick, title } = this.props;
    const items = Object.keys(propTypes)
      .filter(key => exclude.indexOf(key) === -1 && INVALID.indexOf(propTypes[key]) === -1)
      .map((key, index) =>
        <div key={index} className="property">
          <label htmlFor={key}>{key}</label>
          {createField(key)}
        </div>);

    return (
      <Accordion className="properties" expanded={expanded} title={title} onClick={onClick}>
        <div className="propertiy-list">
          {items}
          {children ? <div className="divider"/> : undefined}
          {children}
        </div>
      </Accordion>
    );
  }

}
